export { default } from './TripDuration';
